import { FormProvider } from "react-hook-form";
import { OrganizationScope, ScopeType, SpaceScope } from "~/hooks/useScope";
import { useSetup } from "./hooks/useSetup";
import { SecurityPipelineGithubSetupStepOne } from "./SecurityPipelineGithubSetupStepOne";
import { SecurityPipelineGithubSetupStepTwo } from "./SecurityPipelineGithubSetupStepTwo";
import { SecurityPipelineGithubSetupStepThree } from "./SecurityPipelineGithubSetupStepThree";
import { SecurityPipelineGithubSetupReset } from "./SecurityPipelineGithubSetupReset";

export interface SecurityPipelineGithubSetupProps {
  scope: SpaceScope | OrganizationScope;
  integrationId: string;
  canCreateIntegration: boolean;
}

export const SecurityPipelineGithubSetup = ({
  scope,
  integrationId,
  canCreateIntegration,
}: SecurityPipelineGithubSetupProps) => {
  const {
    formMethods,
    appInstallationLink,
    repositories,
    pairedSpacesNames,
    onSubmit,
    watchRepoName,
    onChangePairing,
    isConfirmationDialogOpen,
    handleOpenConfirmationDialog,
    handleCloseConfirmationDialog,
    handleResetSecurityPipeline,
    isLoading,
  } = useSetup({
    scope,
    integrationId,
    canCreateIntegration,
  });

  return (
    <FormProvider {...formMethods}>
      <form onSubmit={formMethods.handleSubmit(onSubmit)}>
        <SecurityPipelineGithubSetupStepOne
          formMethods={formMethods}
          watchRepoName={watchRepoName}
        />
        <SecurityPipelineGithubSetupStepTwo
          appInstallationLink={appInstallationLink}
        />
        <SecurityPipelineGithubSetupStepThree
          repositories={repositories}
          onChangePairing={onChangePairing}
          pairedSpacesNames={pairedSpacesNames}
        />
      </form>
      {scope.type === ScopeType.Organization && (
        <SecurityPipelineGithubSetupReset
          onOpenConfirmationDialog={handleOpenConfirmationDialog}
          onCloseConfirmationDialog={handleCloseConfirmationDialog}
          onConfirmConfirmationDialog={handleResetSecurityPipeline}
          isConfirmationDialogOpen={isConfirmationDialogOpen}
          isLoading={isLoading}
        />
      )}
    </FormProvider>
  );
};
